const PLUGIN_NAME = 'list-query-variables-plugin';
const LIST_TO_TARGET = ['related-blog', 'related-speakers'];
const SPEAKER_RELATION_FILTER = 'speakerIds.keyword';
const TAG_RELATION_FILTER = 'tagIds.keyword';
const TOPIC_RELATION_FILTER = 'speakerTopicIds.keyword';
const ID_FILTER_NAME = 'id';

export {
  PLUGIN_NAME,
  LIST_TO_TARGET,
  SPEAKER_RELATION_FILTER,
  TAG_RELATION_FILTER,
  ID_FILTER_NAME,
  TOPIC_RELATION_FILTER
};
